import type { VisualizationSampleContainer } from '../../../View/Component/SampleGrouping/VisualizationSampleContainer.js'
import type { SerializableFieldsIndex } from './VisualizationSerializableFields.js'
import type { Metadatafieldtypes } from '../../../View/Component/SampleGrouping/MetadataFields.js'
import { STATIC_METADATA_FIELDS } from '../../../View/Component/SampleGrouping/MetadataFields.js'

export function computeFieldsIndex(samples: VisualizationSampleContainer[]): SerializableFieldsIndex {
  const staticKeys = Object.keys(STATIC_METADATA_FIELDS) as Metadatafieldtypes[]
  const customKeySet = new Set<string>()
  for (const s of samples) {
    const attrs = s.sampleMetadata?.customAttributes
    if (!attrs) continue
    for (const k of Object.keys(attrs)) customKeySet.add(k)
  }
  return { staticKeys, customKeys: Array.from(customKeySet).sort() }
}
